import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const getEmailTemplates = (queryRequest: string) =>
  get(`${config.API_URL}/email-template?${queryRequest}`);

export const createEmailTemplate = (payload: object) =>
  post(`${config.API_URL}/email-template`, payload);

export const getSpecificEmailTemplate = (id: string) =>
  get(`${config.API_URL}/email-template/${id}`);

export const getEmailTemplateKeys = (queryRequest: string) =>
  get(`${config.API_URL}/email-template/get-keys?${queryRequest}`);

export const getEmailTemplateTypes = (queryRequest: string) =>
  get(`${config.API_URL}/email-template/get-types?${queryRequest}`);

export const updateEmailTemplate = (id: string, payload: object) =>
  patch(`${config.API_URL}/email-template/${id}`, payload);

export const deleteEmailTemplate = (id: string) =>
  Delete(`${config.API_URL}/email-template/${id}`);

export const getEmailLog = (queryRequest: string) =>
  get(`${config.API_URL}/email-template/email-log?${queryRequest}`);

export const downloadEmailLog = (payload: object) =>
  post(`${config.API_URL}/reports/export-email-log`, payload);

//List
export const getUserGuideList = (queryRequest: string) =>
  get(`${config.API_URL}/user-guide?${queryRequest}`);

//Create
export const createUserGuide = (payload: object) =>
  post(`${config.API_URL}/user-guide`, payload);

//View Specific
export const getUserGuide = (id: string) =>
  get(`${config.API_URL}/user-guide/${id}`);

//Edit Specific
export const updateUserGuid = (id: string, payload: object) =>
  patch(`${config.API_URL}/user-guide/${id}`, payload);


// Legacy Task 
export const getLegacyTaskList = (queryRequest: string) =>
  get(`${config.API_URL}/legacy-tasks?${queryRequest}`);

export const getSpecificLegacyTask = (id: string) =>
  get(`${config.API_URL}/legacy-tasks/${id}`);

export const getSpecificLegalTaskTaskHistory = (
  id: string,
  payload: object
) =>
  post(
    `${config.API_URL}/legacy-tasks/${id}/task-history`,payload
  );

//Edit Legacy Task
export const UpdateLegacyTask = (id: string, payload: object) =>
  patch(`${config.API_URL}/legacy-tasks/${id}`, payload);


//Download File Legacy Task
export const DownloadLegacyTaskFile = (filekey: string) =>
get(
  `${config.API_URL}/legacy-tasks/download/document?filekey=${filekey}`
);


export const getTaskDocument = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance-task/task/document?${queryRequest}`);

export const getComplianceCertificateConfig = (queryRequest: string) =>
  get(`${config.API_URL}/certificate/config?${queryRequest}`);

export const getComplianceCertificateConfigKeys = (queryRequest: string) =>
  get(`${config.API_URL}/certificate/config/keys?${queryRequest}`);


export const createComplianceCertificateConfig = (payload: object) =>
  post(`${config.API_URL}/certificate/config`, payload);

export const updateComplianceCertificateConfig = (id: string, payload: object) =>
  patch(`${config.API_URL}/certificate/config/${id}`, payload);

export const getLegacyTaskFilterList = (queryRequest: string) =>
  get(`${config.API_URL}/legacy-tasks/filter?${queryRequest}`);
